<div class="pr" [class.pr--con-pie]="hayPie">
  <!-- ==================== ENCABEZADO ==================== -->
  <header class="pr__top">
    <div class="pr__id">
      <span class="pr__marca" aria-hidden="true">
        <span class="material-icons" aria-hidden="true">auto_awesome</span>
      </span>
      <div class="pr__id-txt">
        <h2>Prompts</h2>
      </div>
    </div>

    <!-- La barra de herramientas. Todo mide 40px de alto —la búsqueda,
         la bandeja de administración y el botón— para que se lea como una
         sola línea. La acción principal va sola y sólida al final, para
         que nada compita con ella. -->
    <div class="pr__herr">
      <label class="pr__buscar">
        <span class="material-icons" aria-hidden="true">search</span>
        <input
          type="text"
          [(ngModel)]="texto"
          name="texto"
          aria-label="Buscar prompts"
          [placeholder]="
            secciones.length > 1 ? 'Buscar en todas las áreas…' : 'Buscar…'
          "
        />
        <button
          type="button"
          class="pr__buscar-x"
          *ngIf="texto"
          (click)="texto = ''"
          aria-label="Limpiar la búsqueda"
        >
          <span class="material-icons" aria-hidden="true">close</span>
        </button>
      </label>

      <ng-container *ngIf="puedeAdministrar">
        <!-- Tres botones con marco, cada uno con su color: azul para quién
             lo ve, ámbar para lo retirado, verde para crear. Antes eran
             texto sobre un riel gris y no se leían como botones. -->
        <div class="pr__admin" role="group" aria-label="Administrar el catálogo">
          <button
            type="button"
            class="pr__admin-b pr__admin-b--gente"
            (click)="abrirAreas()"
            matTooltip="Qué áreas de la empresa ven el catálogo"
          >
            <span class="material-icons" aria-hidden="true">groups</span>
            Quién lo ve
            <span class="pr__admin-n" *ngIf="lectores != null">{{ lectores }}</span>
          </button>
          <!-- Sólo cuando hay algo que recuperar: un botón que siempre
               lleva a una lista vacía es un botón muerto. -->
          <button
            type="button"
            class="pr__admin-b pr__admin-b--papel"
            *ngIf="cuantosRetirados > 0"
            (click)="abrirRetirados()"
            matTooltip="Prompts dados de baja"
          >
            <span class="material-icons" aria-hidden="true">history</span>
            Retirados
            <span class="pr__admin-n">{{ cuantosRetirados }}</span>
          </button>
          <button
            type="button"
            class="pr__admin-b pr__admin-b--area"
            (click)="nuevaSeccion()"
            matTooltip="Un área nueva del catálogo"
          >
            <span class="material-icons" aria-hidden="true">create_new_folder</span>
            Nueva área
          </button>
        </div>

        <button
          type="button"
          class="pr__btn"
          (click)="nuevoPrompt()"
          [disabled]="!secciones.length"
        >
          <span class="material-icons" aria-hidden="true">add</span>
          Nuevo prompt
        </button>
      </ng-container>
    </div>
  </header>

  <!-- ==================== EL ÁREA ABIERTA ==================== -->
  <!-- Sin áreas no hay nada que abrir: es el primer administrador, o se
       eliminó la única. Antes la pantalla se quedaba en blanco. -->
  <div class="pr__hueco" *ngIf="!cargando && !error && !secciones.length">
    <span class="material-icons" aria-hidden="true">create_new_folder</span>
    <p *ngIf="puedeAdministrar">Todavía no hay áreas. Crea la primera y agrégale prompts.</p>
    <p *ngIf="!puedeAdministrar">Todavía no hay prompts cargados.</p>
    <button type="button" class="pr__btn" *ngIf="puedeAdministrar" (click)="nuevaSeccion()">
      <span class="material-icons" aria-hidden="true">create_new_folder</span>
      Crear la primera área
    </button>
  </div>

  <div class="pr__panel" *ngIf="seccionActiva as s">
    <!-- ============ LA BARRA: ÁREAS Y ORDEN ============
         Las áreas a la izquierda, como segmentado, y el orden a la
         derecha: una sola barra con las dos cosas que acotan la lista.
         Buscando, la cuenta de cada área dice dónde hay resultados sin
         tener que entrar a probarlas una por una. El color de la activa
         entra por --pr-area y lo compone el CSS, para que el tema lo
         pueda aclarar sobre fondo oscuro. -->
    <div class="pr__filtros">
      <div
        class="pr__seg pr__seg--areas"
        role="tablist"
        aria-label="Áreas del catálogo"
        *ngIf="secciones.length > 1"
      >
        <button
          type="button"
          class="pr__seg-b pr__area"
          role="tab"
          *ngFor="let a of secciones; trackBy: trackSeccion"
          [attr.aria-selected]="tabActiva === a.idPromptSeccion"
          [class.is-on]="tabActiva === a.idPromptSeccion"
          [class.is-sin]="hayFiltros && !coincidencias(a)"
          [style.--pr-area]="colorSeccion(a)"
          (click)="abrirTab(a)"
        >
          <span class="material-icons" aria-hidden="true">{{ a.icono || "folder" }}</span>
          {{ a.nombre }}
          <span class="pr__seg-n">
            {{ hayFiltros ? coincidencias(a) : (a.prompts || []).length }}
          </span>
        </button>
      </div>

      <!-- Con una sola área no hay pestañas: el número de prompts ocupa
           su lugar, que es lo único útil que decían. -->
      <span class="pr__cuantos" *ngIf="secciones.length === 1">
        {{ visiblesSinIa.length }} {{ visiblesSinIa.length === 1 ? "prompt" : "prompts" }}
      </span>

      <div class="pr__orden">
        <span class="pr__orden-et">Orden</span>
        <div class="pr__seg" role="group" aria-label="Ordenar">
          <button
            type="button"
            class="pr__seg-b"
            *ngFor="let o of ORDENES"
            [class.is-on]="orden === o.clave"
            [attr.aria-pressed]="orden === o.clave"
            (click)="ordenar(o.clave)"
          >
            {{ o.texto }}
          </button>
        </div>
      </div>

      <button
        type="button"
        class="pr__limpiar"
        *ngIf="hayAjustes"
        (click)="limpiaFiltros()"
      >
        <span class="material-icons" aria-hidden="true">close</span>
        Limpiar
      </button>
    </div>

    <!-- La cabecera del área abierta: de qué es, qué junta y, para quien
         administra, lo que se le puede hacer, con su nombre escrito. -->
    <div class="pr__panel-cab" #cabArea [style.--pr-area]="colorSeccion(s)">
      <span class="pr__panel-ico" aria-hidden="true">
        <span class="material-icons" aria-hidden="true">{{ s.icono || "folder" }}</span>
      </span>
      <div class="pr__panel-txt">
        <h3 class="pr__panel-nombre">{{ s.nombre }}</h3>
        <p class="pr__panel-desc" *ngIf="s.descripcion">{{ s.descripcion }}</p>
      </div>

      <div class="pr__panel-acc" *ngIf="puedeAdministrar">
        <button type="button" class="pr__accion" (click)="editarSeccion(s)">
          <span class="material-icons" aria-hidden="true">edit</span>
          Editar área
        </button>
        <button
          type="button"
          class="pr__accion pr__accion--no"
          (click)="eliminarSeccion(s)"
          matTooltip="Eliminar el área"
          aria-label="Eliminar el área"
        >
          <span class="material-icons" aria-hidden="true">delete_outline</span>
        </button>
      </div>
    </div>

    <!-- Las tarjetas. Sólo lo necesario para decidir si sirve: arriba el
         largo (y, a quien administra, editar y retirar), en medio el
         título y para qué sirve, abajo las dos acciones. El prompt
         completo vive en el modal. -->
    <div class="pr__cards" *ngIf="enPagina.length">
      <article
        class="pr__card"
        *ngFor="let p of enPagina; trackBy: trackPrompt"
        [style.--pr-ia]="colorDe(p)"
      >
        <div class="pr__fila-meta">
          <span class="pr__lineas">
            <span class="material-icons" aria-hidden="true">notes</span>
            {{ textoLineas(p) }}
          </span>

          <span class="pr__card-admin" *ngIf="puedeAdministrar">
            <button
              type="button"
              class="pr__mini"
              (click)="editar(p)"
              matTooltip="Editar"
              aria-label="Editar el prompt"
            >
              <span class="material-icons" aria-hidden="true">edit</span>
            </button>
            <button
              type="button"
              class="pr__mini pr__mini--no"
              (click)="eliminar(p)"
              matTooltip="Eliminar"
              aria-label="Eliminar el prompt"
            >
              <span class="material-icons" aria-hidden="true">delete_outline</span>
            </button>
          </span>
        </div>

        <div class="pr__card-alto">
          <h4>{{ p.titulo }}</h4>
          <p class="pr__para" *ngIf="p.paraQueSirve">{{ p.paraQueSirve }}</p>
        </div>

        <div class="pr__card-pie">
          <button type="button" class="pr__ver" (click)="ver(p)">
            <span class="material-icons" aria-hidden="true">visibility</span>
            Ver
          </button>

          <button
            type="button"
            class="pr__copiar"
            [class.is-listo]="copiado === p.idPrompt"
            [style.background]="copiado === p.idPrompt ? null : colorDe(p)"
            [style.borderColor]="copiado === p.idPrompt ? null : colorDe(p)"
            (click)="copiar(p)"
          >
            <span class="material-icons" aria-hidden="true">
              {{ copiado === p.idPrompt ? "check" : "content_copy" }}
            </span>
            {{ copiado === p.idPrompt ? "Copiado" : "Copiar" }}
          </button>
        </div>
      </article>
    </div>

    <!-- El área abierta no tiene resultados, pero puede que otra sí:
         se dice y se ofrece el salto, en vez de dejar creer que la
         búsqueda no encontró nada. -->
    <div class="pr__hueco" *ngIf="!enPagina.length">
      <span class="material-icons" aria-hidden="true">{{ hayFiltros ? "search_off" : "note_add" }}</span>

      <ng-container *ngIf="hayFiltros">
        <p *ngIf="texto.trim()">Nada en {{ s.nombre }} coincide con «{{ texto }}».</p>
        <!-- El número es el de ESA área, que es a donde lleva el botón.
             Sumar las demás prometía más de lo que se iba a ver. -->
        <button
          type="button"
          class="pr__btn pr__btn--fantasma"
          *ngIf="primeraConResultados as otra"
          (click)="abrirTab(otra)"
        >
          Ver {{ coincidencias(otra) }}
          {{ coincidencias(otra) === 1 ? "resultado" : "resultados" }} en
          {{ otra.nombre }}
          <ng-container *ngIf="coincidenciasFuera > coincidencias(otra)">
            · {{ coincidenciasFuera - coincidencias(otra) }} más en otras
          </ng-container>
        </button>
        <button
          type="button"
          class="pr__btn pr__btn--fantasma"
          *ngIf="!primeraConResultados"
          (click)="limpiaFiltros()"
        >
          Quitar la búsqueda
        </button>
      </ng-container>

      <ng-container *ngIf="!hayFiltros">
        <p>{{ s.nombre }} todavía no tiene prompts.</p>
        <button
          type="button"
          class="pr__btn"
          *ngIf="puedeAdministrar"
          (click)="nuevoPrompt(s.idPromptSeccion)"
        >
          <span class="material-icons" aria-hidden="true">add</span>
          Agregar el primero
        </button>
      </ng-container>
    </div>
  </div>

  <!-- ==================== PAGINADO ====================
       Una barra compacta y centrada que se queda flotando al pie de la
       ventana mientras se baja por la lista (sticky): siempre a la mano,
       sin tener que llegar al final. Aparece en cuanto el área tiene más
       de lo que cabe en el tamaño más chico, aunque con el escogido quepa
       todo (si no, quien escogía 48 no podía volver a 12). Los números,
       sólo cuando hay más de una página. -->
  <nav class="pr__pag" *ngIf="hayPie" aria-label="Páginas">
    <span class="pr__pag-rango">
      <b>{{ desdeVisible }}–{{ hastaVisible }}</b> de {{ totalVisible }}
    </span>

    <div class="pr__pag-nums" *ngIf="hayPaginado">
      <button
        type="button"
        class="pr__pag-btn pr__pag-btn--flecha"
        [disabled]="pagina === 1"
        (click)="irA(pagina - 1)"
        aria-label="Anterior"
      >
        <span class="material-icons" aria-hidden="true">chevron_left</span>
      </button>

      <button
        type="button"
        class="pr__pag-btn"
        *ngFor="let n of numerosPagina"
        [class.is-on]="n === pagina"
        [class.is-hueco]="n === '…'"
        [disabled]="n === '…'"
        [attr.aria-current]="n === pagina ? 'page' : null"
        (click)="irA(n)"
      >
        {{ n }}
      </button>

      <button
        type="button"
        class="pr__pag-btn pr__pag-btn--flecha"
        [disabled]="pagina === totalPaginas"
        (click)="irA(pagina + 1)"
        aria-label="Siguiente"
      >
        <span class="material-icons" aria-hidden="true">chevron_right</span>
      </button>
    </div>

    <div class="pr__pag-tam">
      <span>Por página</span>
      <button
        type="button"
        class="pr__pag-btn"
        *ngFor="let n of TAMANOS"
        [class.is-on]="porPagina === n"
        [attr.aria-pressed]="porPagina === n"
        (click)="cambiaTamano(n)"
      >
        {{ n }}
      </button>
    </div>
  </nav>

  <div class="pr__cargando" *ngIf="cargandoPrimeraVez">
    <span class="material-icons" aria-hidden="true">hourglass_top</span>
    Cargando…
  </div>

  <div class="pr__error" *ngIf="error">
    <span class="material-icons" aria-hidden="true">error_outline</span>
    {{ error }}
    <button type="button" class="pr__btn pr__btn--fantasma" (click)="cargar()">
      Reintentar
    </button>
  </div>

  <!-- Para el lector de pantalla: el botón cambia a «Copiado», pero
       eso sólo se ve. -->
  <span class="pr__sr" aria-live="polite">{{ copiado != null ? "Prompt copiado" : "" }}</span>
</div>

<!-- ==================== MODAL: VER EL PROMPT ==================== -->
<div class="pr-modal" *ngIf="detalle" (click)="cerrarDetalle()" (keydown.enter)="cerrarDetalle()">
  <!-- El clic no se propaga desde la caja: pulsar dentro no debe cerrar
       lo que estás leyendo. -->
  <div
    class="pr-modal__caja pr-modal__caja--ancha"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pr-ver-titulo"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()"
    [style.--pr-area]="colorDe(detalle)"
    [style.borderTopColor]="colorDe(detalle)"
  >
    <div class="pr-modal__cab">
      <span class="pr-modal__ico" aria-hidden="true">
        <span class="material-icons" aria-hidden="true">{{ seccionDe(detalle)?.icono || "folder" }}</span>
      </span>
      <div class="pr-modal__cab-txt">
        <!-- La meta va encima del título: de qué área es y qué tan largo
             es se leen antes de que el título ocupe la atención. -->
        <div class="pr-modal__meta">
          <span class="pr-sello" *ngIf="seccionDe(detalle) as sd">{{ sd.nombre }}</span>
          <span class="pr__lineas">
            <span class="material-icons" aria-hidden="true">notes</span>
            {{ textoLineas(detalle) }}
          </span>
        </div>
        <h3 id="pr-ver-titulo">{{ detalle.titulo }}</h3>
      </div>
      <button type="button" class="pr-modal__x" (click)="cerrarDetalle()" aria-label="Cerrar">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </div>

    <div class="pr-modal__cuerpo pr-modal__cuerpo--codigo">
      <!-- Lo que devuelve, antes del prompt. Es lo que decide si vale la
           pena leerlo, así que va primero y no enterrado al final. -->
      <div
        class="pr-obtienes"
        *ngIf="detalle.queObtienes"
        [style.background]="tinte(colorDe(detalle), 0.06)"
        [style.borderColor]="tinte(colorDe(detalle), 0.22)"
      >
        <span class="pr-obtienes__etq">
          <span class="material-icons" aria-hidden="true">check_circle</span>
          Qué vas a obtener
        </span>
        <p>{{ detalle.queObtienes }}</p>
      </div>

      <p class="pr-obtienes__para" *ngIf="detalle.paraQueSirve">
        {{ detalle.paraQueSirve }}
      </p>

      <!-- Cada línea es un renglón de rejilla con su número: así el
           número se queda arriba y alineado aunque el texto envuelva.
           Con un <pre> y una columna de números al lado, en cuanto una
           línea envuelve se desfasa todo lo de abajo. -->
      <div class="pr-code" [style.--pr-acento]="colorDe(detalle)">
        <div class="pr-code__barra">
          <span class="pr-code__luces" aria-hidden="true">
            <i></i><i></i><i></i>
          </span>
          <span class="pr-code__etq">prompt</span>
          <span class="pr-code__cuenta">
            Se copia completo, incluido el cierre
          </span>
        </div>

        <div class="pr-code__cuerpo">
          <div
            class="pr-code__linea"
            *ngFor="let l of lineasTexto(detalle); index as i; trackBy: trackLinea"
          >
            <span class="pr-code__num">{{ i + 1 }}</span>
            <span class="pr-code__txt">{{ l }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Copiar, grande y a la derecha: es lo único que hay que hacer aquí.
         A quien administra, «Editar» a la izquierda, para no tener que
         cerrar y buscar la tarjeta. -->
    <div class="pr-modal__pie">
      <button
        type="button"
        class="pr__btn pr__btn--fantasma"
        *ngIf="puedeAdministrar"
        (click)="editarDesdeDetalle()"
      >
        <span class="material-icons" aria-hidden="true">edit</span>
        Editar
      </button>
      <span class="pr-modal__botones">
        <button
          type="button"
          class="pr__copiar pr__copiar--grande"
          [class.is-listo]="copiado === detalle.idPrompt"
          [style.background]="copiado === detalle.idPrompt ? null : colorDe(detalle)"
          [style.borderColor]="copiado === detalle.idPrompt ? null : colorDe(detalle)"
          (click)="copiar(detalle)"
        >
          <span class="material-icons" aria-hidden="true">
            {{ copiado === detalle.idPrompt ? "check" : "content_copy" }}
          </span>
          {{ copiado === detalle.idPrompt ? "Copiado" : "Copiar prompt" }}
        </button>
      </span>
    </div>
  </div>
</div>

<!-- ==================== MODAL: EDITAR PROMPT ====================
     Dos columnas en pantalla ancha: a la izquierda la ficha (cómo se ve
     en el catálogo), a la derecha el prompt, que es lo largo y se lleva
     todo el alto. En pantalla angosta se apilan. -->
<div class="pr-modal" *ngIf="editando">
  <div
    class="pr-modal__caja pr-modal__caja--editor"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pr-editar-titulo"
  >
    <div class="pr-modal__cab">
      <span class="pr-modal__ico" aria-hidden="true">
        <span class="material-icons" aria-hidden="true">{{ editando.idPrompt ? "edit_note" : "note_add" }}</span>
      </span>
      <div class="pr-modal__cab-txt">
        <h3 id="pr-editar-titulo">{{ editando.idPrompt ? "Editar prompt" : "Nuevo prompt" }}</h3>
        <p>
          {{
            editando.idPrompt
              ? "Lo que cambies se ve en el catálogo en cuanto guardes."
              : "Se agrega al área que escojas; sin orden, se va al final."
          }}
        </p>
      </div>
      <button type="button" class="pr-modal__x" (click)="cancelar()" aria-label="Cerrar">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </div>

    <!-- Los tres campos con asterisco son los que el servidor exige; los
         contadores llevan el MISMO tope que él, así que lo que se escribe
         aquí se guarda tal cual: nunca se recorta al llegar. -->
    <div class="pr-modal__cuerpo pr-editor">
      <div class="pr-editor__datos">
        <label class="pr-campo">
          <span class="pr-campo__et">
            Título <b class="pr-req" title="Obligatorio">*</b>
            <span class="pr-campo__cuenta" [class.es-cerca]="cerca(editando.titulo, MAX.titulo)">
              {{ largo(editando.titulo) }}/{{ MAX.titulo }}
            </span>
          </span>
          <input
            type="text"
            [(ngModel)]="editando.titulo"
            name="titulo"
            [maxlength]="MAX.titulo"
            required
            placeholder="Cómo se va a llamar en la lista"
          />
          <!-- Otro prompt ya se llama así: se avisa mientras se escribe.
               Es sólo ayuda; el que lo rechaza es el servidor, que además
               mira los retirados. -->
          <span class="pr-campo__aviso" *ngIf="tituloRepetido as otra">
            <span class="material-icons" aria-hidden="true">warning_amber</span>
            Ya hay un prompt con ese nombre en «{{ otra.nombre }}»: con el mismo nombre no se guarda.
          </span>
        </label>

        <label class="pr-campo">
          <span class="pr-campo__et">Área <b class="pr-req" title="Obligatorio">*</b></span>
          <select [(ngModel)]="editando.idPromptSeccion" name="seccion" required>
            <option *ngFor="let s of secciones" [ngValue]="s.idPromptSeccion">
              {{ s.nombre }}
            </option>
          </select>
        </label>

        <div class="pr-campo__fila pr-campo__fila--orden">
          <label class="pr-campo">
            <span class="pr-campo__et">Para cuál IA</span>
            <select [(ngModel)]="editando.idInventarioIa" name="sistema">
              <option [ngValue]="null">Cualquiera</option>
              <option *ngFor="let x of sistemas" [ngValue]="x.idInventarioIa">
                {{ x.nombreIa }}
              </option>
            </select>
          </label>

          <label class="pr-campo">
            <span class="pr-campo__et">Orden</span>
            <input
              type="number"
              min="0"
              [(ngModel)]="editando.orden"
              name="orden"
              placeholder="Al final"
            />
          </label>
        </div>

        <label class="pr-campo">
          <span class="pr-campo__et">
            Para qué sirve
            <span class="pr-campo__cuenta" [class.es-cerca]="cerca(editando.paraQueSirve, MAX.paraQue)">
              {{ largo(editando.paraQueSirve) }}/{{ MAX.paraQue }}
            </span>
          </span>
          <textarea
            [(ngModel)]="editando.paraQueSirve"
            name="paraQue"
            rows="3"
            [maxlength]="MAX.paraQue"
            placeholder="Qué resuelve, en una o dos líneas. Es lo que alguien lee para decidir si le sirve."
          ></textarea>
        </label>

        <label class="pr-campo">
          <span class="pr-campo__et">
            Qué se obtiene al correrlo
            <span class="pr-campo__cuenta" [class.es-cerca]="cerca(editando.queObtienes, MAX.queObtienes)">
              {{ largo(editando.queObtienes) }}/{{ MAX.queObtienes }}
            </span>
          </span>
          <textarea
            [(ngModel)]="editando.queObtienes"
            name="queObtienes"
            rows="3"
            [maxlength]="MAX.queObtienes"
            placeholder="Qué devuelve el asistente. Es lo que fija la expectativa de quien lo va a usar."
          ></textarea>
        </label>

        <p class="pr-campo__nota">
          <span class="material-icons" aria-hidden="true">info</span>
          <span>
            El orden acomoda las tarjetas dentro del área: menor primero.
            Vacío, el prompt se va al final. Conviene ir de 10 en 10 para
            poder meter uno en medio sin renumerar.
          </span>
        </p>
      </div>

      <div class="pr-editor__prompt">
        <label class="pr-campo pr-campo--prompt">
          <span class="pr-campo__et">
            El prompt <b class="pr-req" title="Obligatorio">*</b>
            <span class="pr-campo__cuenta" [class.es-cerca]="cerca(editando.textoPrompt, MAX.prompt)">
              {{ largo(editando.textoPrompt) }}/{{ MAX.prompt }}
            </span>
          </span>
          <textarea
            class="pr-campo__mono"
            [(ngModel)]="editando.textoPrompt"
            name="texto"
            rows="14"
            [maxlength]="MAX.prompt"
            required
            spellcheck="false"
            placeholder="Pega aquí el prompt tal cual se usa."
          ></textarea>
        </label>
      </div>
    </div>

    <!-- El pie dice qué falta. Un botón apagado sin decir por qué deja a
         quien lo mira sin saber qué hacer. -->
    <div class="pr-modal__pie">
      <span class="pr-modal__falta" [class.es-falta]="faltaPrompt">
        {{ faltaPrompt || "* obligatorio" }}
      </span>
      <span class="pr-modal__botones">
        <button
          type="button"
          class="app-form-btn app-form-btn--secondary app-form-btn--compact"
          (click)="cancelar()"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="app-form-btn app-form-btn--primary app-form-btn--compact"
          [disabled]="guardando || !!faltaPrompt"
          (click)="guardar()"
        >
          {{ guardando ? "Guardando…" : "Guardar" }}
        </button>
      </span>
    </div>
  </div>
</div>

<!-- ==================== MODAL: ÁREA ==================== -->
<div class="pr-modal" *ngIf="editandoSeccion">
  <div
    class="pr-modal__caja pr-modal__caja--chica"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pr-area-titulo"
  >
    <div class="pr-modal__cab">
      <span class="pr-modal__ico" aria-hidden="true">
        <span class="material-icons" aria-hidden="true">
          {{ editandoSeccion.idPromptSeccion ? "folder_open" : "create_new_folder" }}
        </span>
      </span>
      <div class="pr-modal__cab-txt">
        <h3 id="pr-area-titulo">
          {{ editandoSeccion.idPromptSeccion ? "Editar área" : "Nueva área" }}
        </h3>
        <p>Las áreas son las pestañas del catálogo.</p>
      </div>
      <button type="button" class="pr-modal__x" (click)="cancelar()" aria-label="Cerrar">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </div>

    <div class="pr-modal__cuerpo">
      <label class="pr-campo">
        <span class="pr-campo__et">
          Nombre <b class="pr-req" title="Obligatorio">*</b>
          <span class="pr-campo__cuenta" [class.es-cerca]="cerca(editandoSeccion.nombre, MAX.nombre)">
            {{ largo(editandoSeccion.nombre) }}/{{ MAX.nombre }}
          </span>
        </span>
        <input
          type="text"
          [(ngModel)]="editandoSeccion.nombre"
          name="secNombre"
          [maxlength]="MAX.nombre"
          required
          placeholder="Java, Angular, General…"
        />
      </label>

      <label class="pr-campo">
        <span class="pr-campo__et">
          Descripción
          <span class="pr-campo__cuenta" [class.es-cerca]="cerca(editandoSeccion.descripcion, MAX.descripcion)">
            {{ largo(editandoSeccion.descripcion) }}/{{ MAX.descripcion }}
          </span>
        </span>
        <textarea
          [(ngModel)]="editandoSeccion.descripcion"
          name="secDesc"
          rows="3"
          [maxlength]="MAX.descripcion"
          placeholder="Qué tipo de prompts van aquí"
        ></textarea>
      </label>

      <!-- El icono se escoge, no se escribe: antes había que saberse el
           nombre del icono de Material. Un <div> y no un <label>: un
           label pasa el clic de su texto al primer botón de adentro. -->
      <div class="pr-campo">
        <span class="pr-campo__et">
          Icono
          <span class="pr-campo__cuenta">{{ nombreIcono(editandoSeccion.icono || "folder") }}</span>
        </span>
        <!-- Una sola elección entre 45: grupo de radio con un solo punto de
             Tab (el escogido) y flechas para moverse, en vez de 45 paradas.
             El nombre, en español, va en title y no en matTooltip: el
             tooltip salía detrás del modal y en el celular bloqueaba el
             gesto de rodar la rejilla. -->
        <div
          class="pr-iconos"
          role="radiogroup"
          aria-label="Icono del área"
          (keydown)="flechasIcono($event)"
        >
          <button
            type="button"
            class="pr-iconos__b"
            role="radio"
            *ngFor="let i of iconosArea"
            [class.is-on]="(editandoSeccion.icono || 'folder') === i"
            [attr.aria-checked]="(editandoSeccion.icono || 'folder') === i"
            [attr.tabindex]="(editandoSeccion.icono || 'folder') === i ? 0 : -1"
            [attr.aria-label]="nombreIcono(i)"
            [attr.title]="nombreIcono(i)"
            (click)="editandoSeccion.icono = i"
          >
            <span class="material-icons" aria-hidden="true">{{ i }}</span>
          </button>
        </div>
      </div>

      <!-- El orden de una nueva no se pregunta: va después de la última
           pestaña. Al editar sí, para poder moverla de lugar. -->
      <label class="pr-campo pr-campo--orden" *ngIf="editandoSeccion.idPromptSeccion">
        <span class="pr-campo__et">Orden</span>
        <input type="number" [(ngModel)]="editandoSeccion.orden" name="secOrden" />
      </label>

      <p class="pr-campo__nota">
        <span class="material-icons" aria-hidden="true">info</span>
        <span *ngIf="!editandoSeccion.idPromptSeccion">
          Va al final de las pestañas<ng-container *ngIf="ultimaArea as u">,
          después de «{{ u.nombre }}»</ng-container>. El color se asigna solo y
          no cambia aunque después la muevas de lugar. Si el nombre es el de
          un área que se dio de baja, se recupera esa en vez de crear otra.
        </span>
        <span *ngIf="editandoSeccion.idPromptSeccion">
          Las pestañas se acomodan por el orden, menor primero. Se dejan
          huecos (10, 20, 30…) para poder meter una en medio sin renumerar
          todo. El color no cambia aunque la muevas de lugar.
        </span>
      </p>
    </div>

    <div class="pr-modal__pie">
      <span class="pr-modal__falta" [class.es-falta]="faltaSeccion">
        {{ faltaSeccion || "* obligatorio" }}
      </span>
      <span class="pr-modal__botones">
        <button
          type="button"
          class="app-form-btn app-form-btn--secondary app-form-btn--compact"
          (click)="cancelar()"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="app-form-btn app-form-btn--primary app-form-btn--compact"
          [disabled]="guardando || !!faltaSeccion"
          (click)="guardarSeccion()"
        >
          {{ guardando ? "Guardando…" : "Guardar" }}
        </button>
      </span>
    </div>
  </div>
</div>

<!-- ==================== MODAL: QUIÉN LO VE ====================
     Un check por área de la empresa. Marcarla le da acceso a su gente
     según el organigrama; desmarcarla se lo quita. Nada cambia hasta
     Guardar, y el pie dice cuánta gente va a quedar dentro. -->
<div class="pr-modal" *ngIf="areas" (click)="cerrarAreas()" (keydown.enter)="cerrarAreas()">
  <div
    class="pr-modal__caja pr-modal__caja--media"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pr-areas-titulo"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()"
  >
    <div class="pr-modal__cab">
      <span class="pr-modal__ico" aria-hidden="true">
        <span class="material-icons" aria-hidden="true">groups</span>
      </span>
      <div class="pr-modal__cab-txt">
        <h3 id="pr-areas-titulo">Quién ve el catálogo</h3>
        <p>
          Marca las áreas. Su gente, según el organigrama, gana el acceso al
          guardar; desmarcar una se lo quita.
        </p>
      </div>
      <button type="button" class="pr-modal__x" (click)="cerrarAreas()" aria-label="Cerrar">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </div>

    <!-- Las áreas con gente, en tarjetas de dos columnas: la casilla, el
         nombre y cuánta gente. Lo que cambió respecto a lo guardado lleva
         su etiqueta («Se agrega» / «Se quita»), para ver antes de Guardar
         qué se va a prender y qué se va a apagar. Las que no tienen a
         nadie en el organigrama no se pueden marcar: van aparte, abajo,
         en vez de salpicar la lista con renglones apagados. -->
    <div class="pr-modal__cuerpo pr-modal__cuerpo--lista">
      <span class="pr-quien__et" id="pr-quien-con" *ngIf="areasConGente.length">
        Áreas con gente
        <b>{{ areasConGente.length }}</b>
      </span>

      <ul class="pr-areas" aria-labelledby="pr-quien-con" *ngIf="areasConGente.length">
        <li *ngFor="let a of areasConGente; trackBy: trackArea">
          <label
            class="pr-areas__fila"
            [class.is-on]="a.marcada"
            [class.is-sin]="!a.personas"
            [class.is-cambio]="a.marcada !== !!a.habilitada"
          >
            <input
              type="checkbox"
              class="pr-check__in"
              [checked]="a.marcada"
              [disabled]="!a.personas"
              (change)="alternaArea(a)"
            />
            <span class="pr-check" aria-hidden="true">
              <span class="material-icons" aria-hidden="true">check</span>
            </span>
            <span class="pr-areas__txt">
              <span class="pr-areas__nombre">{{ a.nombre }}</span>
              <span class="pr-areas__meta">
                {{ a.personas }} {{ a.personas === 1 ? "persona" : "personas" }}
                <ng-container *ngIf="a.habilitada && a.conAcceso !== a.personas">
                  · {{ a.conAcceso }} con acceso
                </ng-container>
              </span>
            </span>
            <span
              class="pr-areas__cambio"
              *ngIf="a.marcada !== !!a.habilitada"
              [class.es-quita]="!a.marcada"
            >
              {{ a.marcada ? "Se agrega" : "Se quita" }}
            </span>
          </label>
        </li>
      </ul>

      <ng-container *ngIf="areasSinGente.length">
        <span class="pr-quien__et" id="pr-quien-sin">
          Sin nadie en el organigrama
          <b>{{ areasSinGente.length }}</b>
        </span>
        <ul class="pr-sin" aria-labelledby="pr-quien-sin">
          <li
            class="pr-sin__i"
            *ngFor="let a of areasSinGente; trackBy: trackArea"
            [class.is-on]="a.habilitada"
          >
            <span class="material-icons" aria-hidden="true">
              {{ a.habilitada ? "check" : "person_off" }}
            </span>
            {{ a.nombre }}
            <span class="pr__sr" *ngIf="a.habilitada">, marcada (con acceso guardado)</span>
          </li>
        </ul>
      </ng-container>

      <p class="pr-campo__nota">
        <span class="material-icons" aria-hidden="true">info</span>
        <span>
          Quien gane acceso lo verá al volver a entrar: el menú se arma al
          iniciar sesión. Guardar también se lo da a quien haya entrado a un
          área ya marcada después de marcarla.
        </span>
      </p>
    </div>

    <div class="pr-modal__pie">
      <span class="pr-quien__pie">
        <span class="pr-modal__pista pr-modal__pista--dato">{{ resumenAreas }}</span>
        <span class="pr-quien__pend" *ngIf="cambiosAreas">
          {{ cambiosAreas }} {{ cambiosAreas === 1 ? "cambio" : "cambios" }} sin guardar
        </span>
      </span>
      <span class="pr-modal__botones">
        <button
          type="button"
          class="app-form-btn app-form-btn--secondary app-form-btn--compact"
          (click)="cerrarAreas()"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="app-form-btn app-form-btn--primary app-form-btn--compact"
          [disabled]="guardandoAreas || !areasCambiaron"
          (click)="guardarAreas()"
        >
          {{ guardandoAreas ? "Guardando…" : "Guardar" }}
        </button>
      </span>
    </div>
  </div>
</div>

<!-- ==================== MODAL: RETIRADOS ====================
     Nada se borra: lo que se elimina se marca de baja y sigue aquí.
     Hasta ahora eso sólo lo sabía la base de datos; ésta es la otra
     mitad de esa decisión. -->
<div class="pr-modal" *ngIf="retirados" (click)="cerrarRetirados()" (keydown.enter)="cerrarRetirados()">
  <div
    class="pr-modal__caja"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pr-retirados-titulo"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()"
  >
    <div class="pr-modal__cab">
      <span class="pr-modal__ico" aria-hidden="true">
        <span class="material-icons" aria-hidden="true">history</span>
      </span>
      <div class="pr-modal__cab-txt">
        <h3 id="pr-retirados-titulo">Prompts retirados</h3>
        <p>
          Nada se borra del todo. Recupera uno y vuelve a su área, con su
          orden, como estaba.
        </p>
      </div>
      <button
        type="button"
        class="pr-modal__x"
        (click)="cerrarRetirados()"
        aria-label="Cerrar"
      >
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </div>

    <div class="pr-modal__cuerpo pr-modal__cuerpo--lista">
      <div class="pr__cargando" *ngIf="cargandoRetirados">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        Cargando…
      </div>

      <ul class="pr-papel" *ngIf="!cargandoRetirados && retirados.length">
        <li *ngFor="let p of retirados; trackBy: trackPrompt">
          <div class="pr-papel__txt">
            <h4>{{ p.titulo }}</h4>
            <p class="pr__para" *ngIf="p.paraQueSirve">{{ p.paraQueSirve }}</p>
            <span class="pr-papel__meta">
              {{ p.nombreSeccion }}
              <ng-container *ngIf="p.nombreIa"> · {{ p.nombreIa }}</ng-container>
              <ng-container *ngIf="p.modificoNombre">
                · lo retiró {{ p.modificoNombre }}
              </ng-container>
              <ng-container *ngIf="p.fechaModificacion">
                · {{ p.fechaModificacion }}
              </ng-container>
            </span>
            <!-- Su área también está retirada: se dice qué hacer, en vez
                 de dejar un botón que va a fallar. -->
            <span class="pr-papel__aviso" *ngIf="!p.seccionActiva">
              <span class="material-icons" aria-hidden="true">info</span>
              El área «{{ p.nombreSeccion }}» está retirada. Da de alta un área
              con ese mismo nombre y se recupera; después vuelve aquí.
            </span>
          </div>

          <button
            type="button"
            class="pr__btn pr__btn--fantasma pr__btn--chico"
            [disabled]="!p.seccionActiva || restaurando != null"
            (click)="restaurar(p)"
          >
            <span class="material-icons" aria-hidden="true">restore</span>
            {{ restaurando === p.idPrompt ? "Recuperando…" : "Recuperar" }}
          </button>
        </li>
      </ul>

      <div class="pr__hueco" *ngIf="!cargandoRetirados && !retirados.length">
        <span class="material-icons" aria-hidden="true">inbox</span>
        <p>No hay nada retirado.</p>
      </div>
    </div>

    <div class="pr-modal__pie">
      <span class="pr-modal__botones">
        <button
          type="button"
          class="app-form-btn app-form-btn--secondary app-form-btn--compact"
          (click)="cerrarRetirados()"
        >
          Cerrar
        </button>
      </span>
    </div>
  </div>
</div>
